import { useMutation } from '@tanstack/react-query';
import { useTranslationCapManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { showToastV2 } from '@dealstack/frontend/shared/mechanism/toast/useToastV2';
import { SecurityType, CurrencyType } from '@dealstack/shared/lib/generated';
import { bulkCreateSecurities } from '@dealstack/frontend/shared/dataExchange/services/securities';

export const useCreateSecurity = ({
	issuerPersonId,
	mipId,
	onSuccess,
	currency = CurrencyType.EUR,
}: {
	issuerPersonId?: string;
	mipId: string;
	onSuccess?: () => void;
	currency?: CurrencyType;
}) => {
	const tCapManage = useTranslationCapManage();

	return useMutation({
		mutationFn: (data: {
			name: string;
			type: SecurityType;
			currency?: CurrencyType;
			isSubjectToVesting: boolean;
			fairMarketValuePerUnit?: number | null;
		}) => {
			if (!issuerPersonId) {
				throw new Error('Issuer person id is required to create a MIP security');
			}

			return bulkCreateSecurities({
				issuerId: issuerPersonId,
				securities: [
					{
						name: data.name,
						type: data.type,
						currency: data.currency ?? currency,
						fairMarketValuePerUnit: data.fairMarketValuePerUnit,
						securityProgrammeSettings: {
							mipId,
							isSubjectToVesting: data.isSubjectToVesting,
						},
					},
				],
			});
		},
		onSuccess: (response) => {
			const count = Array.isArray(response) ? response.length : response?.count ?? 1;

			showToastV2({
				message: `${count} ${tCapManage('toasts.success.security_uploaded_successfully')}`,
			});
			onSuccess?.();
		},
	});
};
